import * as env from '../env';

export const MapProviders = {
    normal: 'normal',
    satellite: 'satellite'
}

const mapBoxToken = 'pk.eyJ1IjoiY3VlYmx5IiwiYSI6ImNtZjJpcGExeTIyZGQya3F4aGdrdWg0NGgifQ.agBx3c2KAQHczroWxzPthA';

export const MapProvider = (type, lang) => {
    if(type === MapProviders.satellite) return '//{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&hl=' + (lang || 'en');
    if(env.isDevelopment()) return '//{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    return `//api.mapbox.com/styles/v1/cuebly/cmf59ub4601qe01qw8gp5gbos/tiles/256/{z}/{x}/{y}@2x?access_token=${mapBoxToken}`;
}

export const getCentroid = arr => arr.reduce((x,y) => [x[0] + y[0]/arr.length, x[1] + y[1]/arr.length], [0,0]);